import React, {Component} from 'react';
import {Link} from 'react-router';
import Translate from '../layout/Translate';
import Review from './Review';
import ReviewsConditions from '../popups/ReviewsConditions';
import moment from 'moment';

export default class Reviews extends Component {


    componentWillMount() {



    }


    componentWillUpdate() {



    }

    openReview(review, i) {
        this.props.actions.openReview(i);
    }

    toggleReviewRate(review, i) {
        this.props.actions.toggleReviewRate(i);
    }

    openReviews() {
        this.props.actions.openReviews();
    }

    selectLang() {
        this.props.actions.selectReviewsLang();
    }


    openPopup() {
        this.props.userActions.toggleReviewsPopup();
    }

    loadReviews(lang, page, selected) {
        if (!this.props.fetchReviews && !selected) {
            if (this.props.list) {
                this.props.actions.fetchAllReviews(page?page:this.props.openedReviews+1, lang);
            } else {
                this.props.actions.fetchReviews(this.props.tourId, page?page:this.props.openedReviews+1, lang);
            }
        }
    }


    render() {
        let { reviews, lang, destinations, reviewsPopupOpen, reviewsLang } = this.props;

        moment.locale(lang);

        let tourReviews = [],
            destinationsReviews = [],
            allReviews = [];


        reviews.forEach(function(review){
            review.start_moment = moment(review.start_at * 1000);
            review.end_moment = moment(review.end_at * 1000);
            review.formated_start_date = review.start_moment.format('D MMMM YYYY');
            review.formated_end_date = review.end_moment.format('D MMMM YYYY');

            let re = /<[^>]+>/g;

            let description = (review.comment)?review.comment.replace(re, ''):"";
            description = description.substr(0, 405);
            let lastSpace = description.lastIndexOf(" ");
            if( lastSpace > 0 && description.length > 400) {
                description = description.substr(0, lastSpace);
            }

            let answer = (review.answer)?review.answer.replace(re, ''):"";
                answer = answer.substr(0, 405);
            let answerLastSpace = answer.lastIndexOf(" ");
            if( answerLastSpace > 0 && answer.length > 400) {
                answer = answer.substr(0, lastSpace);
            }

            review.preview = description;
            review.previewAnswer = answer;

            switch (review.type) {
                case "2":
                    tourReviews.push(review);
                case "1":
                    destinationsReviews.push(review);
                case "0":
                    allReviews.push(review);
            }


        });
        
        return (

            <div>
                {reviews &&
                    <div className="reviews__container">
                        {!this.props.list &&
                            <div className="tour__title"><span><Translate slug="reviews__title"/></span></div>
                        }
                        <div className="reviews__how-work">
                                <button className={"reviews__button reviews__button_left " + (!reviewsLang?"reviews__button_active":"")} onClick={this.loadReviews.bind(this, false, 1, !reviewsLang)}>
                                    <Translate slug="reviews__without-lang"/>
                                </button>
                                <button className={"reviews__button reviews__button_left " + (reviewsLang?"reviews__button_active":"")} onClick={this.loadReviews.bind(this, lang, 1, !!reviewsLang)}>
                                    <Translate slug="reviews__by-lang"/> <Translate slug={"reviews__on_" + lang} />
                                </button>
                            <button className="reviews__button" onClick={this.openPopup.bind(this)}>
                                <Translate slug="reviews__how-work"/>
                            </button>
                        </div>
                        <div className="review__list">
                            {reviews.map((review, i)=>
                                <div className={"reviews__block reviews__block_show" }>

                                    {reviews[i].type == "2" && (!i || (i && reviews[i-1].type == "3")) &&
                                    <div className="reviews__note">
                                        <Translate slug="reviews__destinations" />
                                            {destinations &&
                                            <div className="reviews__links">
                                                {destinations.map((destination, index)=>
                                                <span>
                                                    <Link to={"/destinations/" + destination.slug}>
                                                        {destination.title}
                                                    </Link>
                                                    {destinations.length > index+1 && ', '}
                                                </span>
                                            )}

                                            </div>
                                            }
                                    </div>
                                    }
                                    {reviews[i].type == "1" && (!i || (i && reviews[i-1].type == "2") || (i && reviews[i-1].type == "3")) &&
                                    <div className="reviews__note">
                                        <Translate slug="reviews__all" />
                                    </div>
                                    }
                                    <Review actions={this.props.actions} review={review} i={i} />
                                </div>
                            )}

                        </div>
                        {this.props.reviewsPageCount != this.props.openedReviews &&
                            <button className={"reviews__more " + (this.props.fetchReviews?"reviews__more_fetch":"")}
                                    onClick={this.loadReviews.bind(this, reviewsLang, false, false)}><span><Translate
                                slug="reviews__more"/> {this.props.list ? 20 : 5}</span></button>
                        }
                    </div>
                }

                <ReviewsConditions open={reviewsPopupOpen} toggle={this.props.userActions.toggleReviewsPopup} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/tour/Reviews.js